<template>
  <a
    :href="anchor"
    :class="{
      'player-details__anchor': true,
      'player-details__anchor--active': renderAnchorActiveClassName
    }"
    :style="{ color: color }"
    >{{ text }}</a
  >
</template>

<script>
export default {
  name: "CommonAnchorLink",
  props: {
    anchor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false
    }
  },
  computed: {
    renderAnchorActiveClassName() {
      return this.anchor === this.$route?.hash;
    }
  }
};
</script>

<style scoped>
.player-details__anchor {
  text-decoration: none;
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  color: var(--grey-color);
}

.player-details__anchor--active {
  color: var(--dark-color);
}
</style>
